// extracted by mini-css-extract-plugin
export default {"list":"HomeBesooktErrorFallback_list__9Z9Ei","item":"HomeBesooktErrorFallback_item__HOKWG"};